import { useState } from 'react';

import { FilterToggleButton } from '@app/components/molecules/filter-toggle-button';
import { FiltersDrawer } from '@app/components/organisms/filters-drawer';
import { ListingFiltersDrawerProps } from '@app/components/organisms/listing-filters/listing-filters-drawer/listing-filters-drawer.props';

export const ListingFiltersDrawer = ({
    onApplyFilters,
    children,
    ...props
}: ListingFiltersDrawerProps) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
            <FilterToggleButton onClick={() => setIsOpen(true)} />
            <FiltersDrawer
                isOpen={isOpen}
                onApplyFilters={() => {
                    onApplyFilters();
                    setIsOpen(false);
                }}
                {...props}
            >
                {children}
            </FiltersDrawer>
        </>
    );
};
